module.exports = __webpack_public_path__ + "static/media/bomb.66e06aa3.svg";